import { createI18n } from 'vue-i18n';

import { i18nConfig } from './config';

const i18n = createI18n({
  legacy: true,
  ...i18nConfig,
});

// Vue-2-style module-level API (i18n.t / i18n.tc / i18n.te) used across the codebase;
// in vue-i18n 9 these live on i18n.global (a VueI18n instance in legacy mode)
interface IModuleLevelI18n {
  t: (...args: unknown[]) => string;
  tc: (...args: unknown[]) => string;
  te: (...args: unknown[]) => boolean;
  setLocaleMessage: (locale: string, messages: unknown) => void;
}

const globalI18n = i18n.global as unknown as IModuleLevelI18n;

(i18n as unknown as Record<string, unknown>).t = globalI18n.t.bind(globalI18n);
(i18n as unknown as Record<string, unknown>).tc = globalI18n.tc.bind(globalI18n);
(i18n as unknown as Record<string, unknown>).te = globalI18n.te.bind(globalI18n);
(i18n as unknown as Record<string, unknown>).setLocaleMessage = globalI18n.setLocaleMessage.bind(globalI18n);

// typed with the methods copied above so `i18n.t(...)` callers type-check
export default i18n as typeof i18n & IModuleLevelI18n;
